import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiLock } from "react-icons/fi";

const ProtectedPage = ({ children }) => {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [inputPassword, setInputPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is "admin"
    const username = localStorage.getItem("username");
    if (username === "admin") {
      setIsUnlocked(true); // Automatically unlock for admin
    } else {
      const pageUnlocked = localStorage.getItem("protectedPageUnlocked");
      if (pageUnlocked === "true") {
        setIsUnlocked(true); // Check if the page was previously unlocked
      }
    }
  }, []);

  const handleUnlock = () => {
    const sharedPassword = "your_password"; // Replace with your shared password
    if (inputPassword === sharedPassword) {
      setIsUnlocked(true);
      localStorage.setItem("protectedPageUnlocked", "true"); // Remember page unlock state
    } else {
      setErrorMessage("Incorrect password. Please try again.");
    }
  };

  if (isUnlocked) {
    return children; // Render the protected content if unlocked
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
    <div className="p-6 bg-white rounded shadow-md w-96 text-center">
      <div className="text-5xl text-blue-500 mb-4">
        <span className="e-icons e-lock" style={{ color: '#03c9d7' }}></span>
      </div>
      <h2 className="text-2xl font-bold mb-4">Locked</h2>
      <p className="mb-4 text-gray-600">
        This page is locked. Only Administrator can have access to this page.
      </p>
      {/* Commented part for future use */}
      {/* <input
        type="password"
        value={inputPassword}
        onChange={(e) => setInputPassword(e.target.value)}
        className="w-full px-3 py-2 mb-4 border rounded"
        placeholder="Enter password"
      /> 
      <button
        onClick={handleUnlock}
        className="w-full bg-teal-400 text-white py-2 rounded hover:bg-teal-500"
        style={{ backgroundColor: '#03c9d7' }}
      >
        Unlock
      </button>*/}
    </div>
  </div>
  );
};

export default ProtectedPage;
